import { useMemo } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useUserSelector } from 'js/store/hooks';
import { useFormatter } from 'js/hooks/useFormatter';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { useVisualDates } from '../../useVisualDates';

export const useExportSummary = () => {
    const formatter = useFormatter();
    const translate = useComponentTranslations();
    const userName = useUserSelector(prop('userName'));
    const { startTime, endTime } = useVisualDates();
    const startDate = formatter.date(startTime);
    const endDate = formatter.date(endTime);
    const startEndPeriod = translate('summary.startEnd.period', [startDate, endDate]);

    return useMemo(() => {
        const dateRange = [{ [translate('total.title.summary')]: startEndPeriod }];
        const playerName = [{ [translate('summary.title.player')]: userName }];

        return { dateRange, playerName };
    }, [translate, userName, startEndPeriod]);
};
